module.exports = __webpack_public_path__ + "static/fonts/iconfont.15b6bdd0.woff";